/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { subwayDuocolor } from "../assets/subway-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSubwayDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={subwayDuocolor.svg} />
);

IllustrativeIconSubwayDuocolor.displayName = "IllustrativeIconSubwayDuocolor";
